const apiUrl = {
  merchant: {
    addMerchant: '/page/index/inscompany',
    getMerchant: '/page/index/selcompany',
    upMerchant: '/page/index/updcompany',
    dleMerchant: '/page/index/delcompany',
    voicechant: '/page/index/updcompanyt',
    //
    addService: '/page/indexs/inscompany',
    getService: '/page/indexs/selcompany',
    upService: '/page/indexs/updcompany',
    dleService: '/page/indexs/delcompany',
    voicechantService: '/page/indexs/updcompany',
    // 
    upsubService: '/page/indexs/updcompanyt',
    // newversionInfo:'api/broadcast/ttssn'
  },
  order: {
    getOrder: '/page/index/seltrade',
    getHome: 'index/index/homepage',
    getSeltrades :'page/index/seltrades'
  },
  login: {
    login: '/index/index/login'
  }

}
export default apiUrl